import {
  buildPreviewDoOrDumpDashboardPayload,
  funnelRowToDashboardPayload,
  type DoOrDumpFunnelRow,
} from "@/lib/do-or-dump-row-to-payload";
import { createSupabaseBrowserClient } from "@/lib/supabase/client";
import type { DoOrDumpDashboardPayload } from "@/types/do-or-dump-dashboard";
import type { DoOrDumpDashboardPreviewReason } from "@/components/dashboard/DoOrDumpReportDashboard";

export async function loadDashboardDoOrDumpReport(): Promise<{
  report: DoOrDumpDashboardPayload;
  preview: boolean;
  previewReason?: DoOrDumpDashboardPreviewReason;
}> {
  const previewReport = buildPreviewDoOrDumpDashboardPayload();
  const sb = createSupabaseBrowserClient();
  const {
    data: { user },
  } = await sb.auth.getUser();
  if (!user?.email) {
    return { report: previewReport, preview: true, previewReason: "sign_in" };
  }

  const email = user.email.trim().toLowerCase();
  const { data: row, error } = await sb
    .from("do_or_dump_funnel_events")
    .select("*")
    .eq("email", email)
    .order("created_at", { ascending: false })
    .limit(1)
    .maybeSingle();

  if (error) {
    console.error("[dashboard]", error);
    return { report: previewReport, preview: true, previewReason: "load_error" };
  }

  if (!row) {
    return {
      report: { ...previewReport, email },
      preview: true,
      previewReason: "no_submission",
    };
  }

  return {
    report: funnelRowToDashboardPayload(row as DoOrDumpFunnelRow),
    preview: false,
  };
}
